import { financialConverter } from '@/converters/financials/financials-converter';
import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class AdminSupplierService {
  async getAll(): Promise<models.AdminSupplierBasicResponse> {
    const suppliers = await appHttpService.request
      .url(`/admin-supplier/`)
      .get()
      .json<models.AdminSupplierBasicResponse>();
    return suppliers;
  }

  async getDetails(id: string): Promise<models.AdminSupplierDetailResponse> {
    const supplier = await appHttpService.request
      .url(`/admin-supplier/${id}`)
      .get()
      .json<models.AdminSupplierDetailResponse>();
    return supplier;
  }

  async createSupplier(body: models.AdminCreateSupplierDetailResponse) {
    const strictBody = financialConverter.toStrict(body);
    return appHttpService.request
      .url(`/admin-supplier/create`)
      .post(strictBody)
      .json<models.AdminSupplierCreateResponse>();
  }

  async updateSupplier(
    id: string,
    { ...body }: models.AdminCreateSupplierDetailResponse,
  ): Promise<models.AdminSupplierDetailResponse | null> {
    const strictBody = financialConverter.toStrict(body);
    return appHttpService.request
      .url(`/admin-supplier/update/${id}`)
      .put(strictBody)
      .res(async (response) => {
        if (response.status === 204) {
          return null;
        }
        return await response.json();
      });
  }

  async deleteSupplier(id: string): Promise<void> {
    await appHttpService.request
      .url(`/admin-supplier/delete/${id}`)
      .json({})
      .delete()
      .res();
  }
}

export const adminSupplierService = new AdminSupplierService();
